export default function base64encode(input) {
  return btoa(input);
}
